import { configureStore } from '@reduxjs/toolkit';

import authReducer from './auth-slice';
import messageReducer from './message-slice';
import drawerReducer from './drawer-slice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    message: messageReducer,
    drawer: drawerReducer,
  },
});

export default store;
